import React, { useEffect } from "react";
import Contact_Banner from "./contact-banner/Contact_Banner";
import Get_In_Touch from "./get-in-touch/Get_In_Touch";
import Map_Contact from "./map-contact/Map-Contact";
import Banner_2 from "./banner_2/Banner_2";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AllAppSetup } from "../../features/admin/common/Slice";

function Contact_Us() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const all_app_setup = useSelector((state) => state?.common?.all_app_setup);

  useEffect(() => {
    dispatch(AllAppSetup());
  }, [dispatch]);
  return (
    <>
      <Contact_Banner />
      <Get_In_Touch all_app_setup={all_app_setup} />
      <Map_Contact all_app_setup={all_app_setup} />
      <Banner_2 />
    </>
  );
}

export default Contact_Us;
